function importAll (r) {
  r.keys().forEach(r);
}

const Cookies = require('js-cookie');

require('./plugins/bootstrap/transition');
require('./plugins/bootstrap/alert');
require('./plugins/bootstrap/button');
require('./plugins/bootstrap/carousel');
require('./plugins/bootstrap/collapse');
require('./plugins/bootstrap/dropdown');
require('./plugins/bootstrap/modal');
require('./plugins/bootstrap/tooltip');
require('./plugins/bootstrap/popover');
require('./plugins/bootstrap/scrollspy');
require('./plugins/bootstrap/tab');
require('./plugins/bootstrap/affix');

importAll(require.context('./vendor/', true, /\.js$/));

var accessError = { status: null, message: "" };

jQuery.fn.exists = function(){ return this.length>0; };

jQuery(document).ready(function($) {

  function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  };

  var discModal       = $('#disclaimerModal');
  var discModalCookie = discModal ? 'STYXKEY_modal-opened-' + discModal.data('modalid') : '';

  $('.close-terms').on( 'click', function (e) {
    e.preventDefault();
    var date = new Date();
    date.setTime(date.getTime() + (60 * 1000));
    $.cookie(discModalCookie, "1", { expires: 1, path: '/' });
    discModal.modal( 'hide' );
  });

  if ( discModal.length > 0 && !$.cookie(discModalCookie)) {
    discModal.modal({
      backdrop : 'static'
    });
  }

  // if( !Cookies.get('STYXKEY_modal-opened') ) {
  //   $('#disclaimerModal').addClass( 'in' );
  // }

  // $('.close-terms').on( 'click', function (e) {
  //   e.preventDefault();
  //   Cookies.set( "STYXKEY_modal-opened", "1", { path: '/' } );
  //   $('#disclaimerModal').removeClass( 'in' );
  // });

  $('.restricted, .restricted a, .restricted button').on( 'click', function (e) {
    e.preventDefault();
    target = $(this).attr('href');
    $('#disclaimerModal').modal();
  });

  $('.accepted').on( 'click', function (e) {
    e.preventDefault();
    accessError.status = false;
    $('#disclaimerModal').modal( 'hide' );
  });

  $('#disclaimerModal').on('hidden.bs.modal', function (e) {
    if( accessError.status === false  ) {
      window.location = target;
    }
  });

  function adjustModalMaxHeightAndPosition(){
    $('.modal').each(function(){
      if($(this).hasClass('in') === false){
        $(this).show();
      }
      var contentHeight = $(window).height() - 60;
      var headerHeight = $(this).find('.modal-header').outerHeight() || 2;
      var footerHeight = $(this).find('.modal-footer').outerHeight() || 2;

      $(this).find('.modal-content').css({
        'max-height': function () {
          return contentHeight;
        }
      });

      $(this).find('.modal-body').css({
        'max-height': function () {
          return contentHeight - (headerHeight + footerHeight);
        }
      });

      $(this).find('.modal-dialog').addClass('modal-dialog-center').css({
        'margin-top': function () {
          return -($(this).outerHeight() / 2);
        },
        'margin-left': function () {
          return -($(this).outerWidth() / 2);
        }
      });
      if($(this).hasClass('in') === false){
        $(this).hide();
      }
    });
  }

  if ($(window).height() >= 320){
    $(window).resize(adjustModalMaxHeightAndPosition).trigger("resize");
  }

});
